import { NgModule } from '@angular/core';
import {MomentFormatPipe} from './moment-format.pipe';
import { SafePipe } from './safe.pipe';
import { VerificacionEstadoPipe } from './verificacion-estado.pipe';


@NgModule({
 imports: [],
 exports: [MomentFormatPipe, SafePipe, VerificacionEstadoPipe],
 declarations: [MomentFormatPipe, SafePipe , VerificacionEstadoPipe],
 providers: [],
})
export class CustomPipesModule { }
